<ng-container *ngIf="!newInvoice && showInvoices">
  <hr class="divider" />
  <button (click)="newInvoice = true" class="blue-btn">
    {{ "billing.gui.buttons.Create New Document" | translate }}
  </button>
</ng-container>

<div *ngIf="showInvoices && newInvoice" class="search-results" [formGroup]="invoiceForm">
  <hr class="divider" />
  <div style="display: flex; flex-direction: row; gap: 2em">
    <h3 style="align-self: center">
      {{ "billing.gui.labels.Create New Document" | translate }}
    </h3>
    <div *ngIf="loginService.clinicUsers" class="inputs-container">
      <div
        [ngClass]="{ 'missing-field': isDoctorMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label [ngClass]="{ 'missing-label': isDoctorMissing, 'label-transition': true }">
          {{ "billing.gui.labels.Doctor" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <select formControlName="doctor" class="t-select-black w100">
            <option *ngFor="let doctor of getDoctors()" [ngValue]="doctor">
              {{ doctor.Title + " " + doctor.Name }}
            </option>
          </select>
        </span>
      </div>
    </div>

    <div *ngIf="loginService.userBilling" class="inputs-container">
      <div
        [ngClass]="{ 'missing-field': isDoctorMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label [ngClass]="{ 'missing-label': isDoctorMissing, 'label-transition': true }">
          {{ "billing.gui.labels.Doctor" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <select formControlName="doctor" class="t-select-black w100">
            <option *ngFor="let doctor of getDoctor()" [ngValue]="doctor">
              {{ doctor.Title + " " + doctor.Name }}
            </option>
          </select>
        </span>
      </div>
    </div>
  </div>
  <div class="inputs-wrapper">
    <!-- ===================== Basic Inputs (Start) ===================== -->

    <div class="inputs-container">
      <div class="l-flex l-flex-c t-field t-field-pad">
        <label>
          {{ "billing.gui.labels.Type" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <select formControlName="documentType" class="t-select-black w100">
            <option *ngFor="let document of documentTypes" [value]="document.value">
              {{ document.label }}
            </option>
          </select>
        </span>
      </div>
    </div>

    <div class="inputs-container" *ngIf="!isQuotation()">
      <div
        [ngClass]="{ 'missing-field': isExamTypeMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label
          *ngIf="!showFreeText"
          [ngClass]="{ 'missing-label': isExamTypeMissing, 'label-transition': true }"
        >
          {{ "billing.gui.labels.Exam Type" | translate }}
        </label>
        <label
          *ngIf="showFreeText"
          [ngClass]="{ 'missing-label': isExamTypeMissing, 'label-transition': true }"
        >
          {{ "billing.gui.labels.Service Type" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <ng-container *ngIf="!showFreeText">
            <select
              formControlName="examType"
              class="t-select-black w100"
              (change)="examChange($event); examTypeNameChange($event)"
            >
              <option
                *ngFor="let exam of availableExams; let i = index"
                [value]="exam.AutoIndex"
                [attr.data-examtype]="exam.examType"
                [attr.data-custom]="exam.custom"
              >
                {{ exam.custom ? exam.examType : exam.examName }}
              </option>
            </select>
          </ng-container>
          <ng-container *ngIf="showFreeText">
            <input formControlName="examType" type="text" class="t-field-text w100" />
          </ng-container>

          <input type="hidden" formControlName="examType_native" />
        </span>
        <i class="t-sep"></i>
        <mat-icon
          *ngIf="!showFreeText"
          (click)="selectChange(); showFreeText = true"
          class="clickable"
          matTooltip="{{ 'billing.gui.tooltips.Toggle to free text' | translate }}"
          >text_format</mat-icon
        >
        <mat-icon
          *ngIf="showFreeText"
          (click)="selectChange(); showFreeText = false"
          class="clickable"
          matTooltip="{{ 'billing.gui.tooltips.Toggle to selection' | translate }}"
          >sort</mat-icon
        >
      </div>
    </div>

    <div class="inputs-container" style="min-width: 35%" *ngIf="!isQuotation()">
      <div
        [ngClass]="{ 'missing-field': isExamNameMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label
          *ngIf="!showFreeText"
          [ngClass]="{ 'missing-label': isExamNameMissing, 'label-transition': true }"
        >
          {{ "billing.gui.labels.Description" | translate }}
        </label>
        <label
          *ngIf="showFreeText"
          [ngClass]="{ 'missing-label': isExamNameMissing, 'label-transition': true }"
        >
          {{ "billing.gui.labels.Service Description" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <input formControlName="examName" type="text" class="t-field-text w100" />
        </span>
        <!-- <span class="t-validation-wrap l-fg1">
                    <select formControlName="examName" class="t-select-black w100">
                        <option *ngFor="let exam of availableExams" [value]="exam.examName">{{exam.examName}}</option>
                    </select>
                </span> -->
      </div>
    </div>

    <div class="w24">
      <div
        [ngClass]="{ 'missing-field': isFirstNameMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label [ngClass]="{ 'missing-label': isFirstNameMissing, 'label-transition': true }">
          {{ currentPatient?.isBusinessClient ? ('appointments.gui.labels.Business Client' | translate) : ('billing.gui.labels.First Name' | translate) }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <input formControlName="firstName" type="text" class="t-field-text w100" />
        </span>
      </div>
    </div>
    <div class="w24" *ngIf="!currentPatient?.isBusinessClient">
      <div
        [ngClass]="{ 'missing-field': isLastNameMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label [ngClass]="{ 'missing-label': isLastNameMissing, 'label-transition': true }">
          {{ "billing.gui.labels.Last Name" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <input formControlName="lastName" type="text" class="t-field-text w100" />
        </span>
      </div>
    </div>
    <div class="w24">
      <div
        [ngClass]="{ 'missing-field': isIDMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
      >
        <label [ngClass]="{ 'missing-label': isIDMissing, 'label-transition': true }">
          {{'appointments.gui.labels.BN ID Number' | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <input formControlName="ID" type="text" class="t-field-text w100" />
        </span>
      </div>
    </div>
    <div class="w24">
      <div class="l-flex l-flex-c t-field t-field-pad">
        <label>
          {{ "billing.gui.labels.Email" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <input formControlName="email" type="text" class="t-field-text w100" />
        </span>
      </div>
    </div>
    <div *ngIf="isQuotation()" formArrayName="items" style="width: 100%">
      <div
        *ngFor="let item of items.controls; let i = index"
        [formGroupName]="i"
        class="l-flex l-flex-c"
        style="gap: 1em; margin-bottom: 0.5em"
      >
        <div class="l-flex l-flex-c t-field t-field-pad" style="min-width: 25%" *ngIf="!showFreeText">
          <label>{{ "billing.gui.labels.Exam Type" | translate }}</label>
          <i class="t-sep"></i>
          <span class="t-validation-wrap l-fg1">
            <select formControlName="examType" class="t-select-black w100" (change)="onItemExamChange($event, i)">
              <option *ngFor="let exam of availableExams" [value]="exam.AutoIndex" [attr.data-examtype]="exam.examType" [attr.data-custom]="exam.custom">
                {{ exam.custom ? exam.examType : exam.examName }}
              </option>
            </select>
          </span>
        </div>
        <div class="l-flex l-flex-c t-field t-field-pad l-fg1">
          <label>{{ "billing.gui.labels.Description" | translate }}</label>
          <i class="t-sep"></i>
          <span class="t-validation-wrap l-fg1">
            <input formControlName="description" type="text" class="t-field-text w100" />
          </span>
        </div>
        <div class="l-flex l-flex-c t-field t-field-pad" style="width: 8em">
          <label>{{ "billing.gui.labels.Quantity" | translate }}</label>
          <i class="t-sep"></i>
          <input formControlName="quantity" class="t-field-text w100" type="number" min="1" step="1" />
        </div>
        <div class="l-flex l-flex-c t-field t-field-pad" style="width: 10em">
          <label>{{ "billing.gui.labels.Price" | translate }}</label>
          <i class="t-sep"></i>
          <input formControlName="price" class="t-field-text w100" type="number" min="0" />
          <span class="t-field-desc"> ₪ </span>
        </div>
        <div class="l-flex l-flex-c t-field t-field-pad" style="width: 9em">
          <label>{{ "billing.gui.labels.Total" | translate }}</label>
          <i class="t-sep"></i>
          <span class="t-field-text">{{ itemTotal(i) | number: "1.0-2" }} ₪</span>
        </div>
        <mat-icon class="clickable" (click)="removeItem(i)">delete</mat-icon>
      </div>
      <div class="l-flex l-flex-c" style="gap: 1em; align-items: center">
        <button type="button" class="blue-btn" (click)="addItem()">+</button>
        <strong>{{ "billing.gui.labels.Total" | translate }}: {{ quotationTotal | number: "1.0-2" }} ₪</strong>
      </div>
    </div>

    <div *ngIf="isQuotation()" style="width: 100%">
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 0.5em">
        <label>{{ "billing.gui.labels.Remarks" | translate }}</label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <textarea formControlName="quotationRemarks" rows="3" class="t-field-text w100"></textarea>
        </span>
      </div>
      <div class="l-flex l-flex-c t-field t-field-pad">
        <label>{{ "billing.gui.labels.General Terms" | translate }}</label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <textarea formControlName="quotationTerms" rows="3" class="t-field-text w100"></textarea>
        </span>
      </div>
    </div>

    <div class="inputs-container" *ngIf="!isQuotation()">
      <div
        [ngClass]="{ 'missing-field': isPriceMissing, 'border-transition': true }"
        class="l-flex l-flex-c t-field t-field-pad"
        style="height: 81%"
      >
        <label [ngClass]="{ 'missing-label': isPriceMissing, 'label-transition': true }">
          {{ "billing.gui.labels.Price" | translate }}
        </label>

        <i class="t-sep"></i>

        <span class="t-validation-wrap l-fg1">
          <span class="t-field t-field--number" style="padding: 0">
            <input formControlName="price" class="t-field-text" type="number" min="0" />
            <span class="t-field-desc"> ₪ </span>
          </span>
        </span>
      </div>
    </div>
    <div class="inputs-container" *ngIf="!isQuotation()">
      <div class="l-flex l-flex-c t-field t-field-pad" style="height: 81%">
        <label>
          {{ "billing.gui.labels.Payment Method" | translate }}
        </label>
        <i class="t-sep"></i>
        <span class="t-validation-wrap l-fg1">
          <select formControlName="paymentMethod" class="t-select-black w100">
            <option *ngFor="let method of paymentMethods" [value]="method.value">
              {{ method.label }}
            </option>
          </select>
        </span>
      </div>
    </div>
    <ng-container *ngIf="currentPatient.IsID === 0">
      <div class="inputs-container">
        <div
          [ngClass]="{
            'missing-field': !invoiceForm.get('countryName').value,
            'border-transition': true
          }"
          class="l-flex l-flex-c t-field t-field-pad"
          style="height: 3em"
        >
          <label
            [ngClass]="{
              'missing-label': !invoiceForm.get('countryName').value,
              'label-transition': true
            }"
          >
            {{ "GUI.Labels.country" | translate }}
          </label>
          <i class="t-sep"></i>
          <span class="t-select w100">
            <input
              type="text"
              class="search-input t-field-text w100"
              [formControl]="invoiceForm.get('countryName')"
              [matAutocomplete]="countryAuto"
            />

            <mat-autocomplete #countryAuto="matAutocomplete" autoActiveFirstOption>
              <mat-option *ngFor="let option of filteredCountries" [value]="option.code">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </span>
        </div>
      </div>
    </ng-container>

    <!-- ===================== Basic Inputs (End) ===================== -->

    <!-- ===================== Checks / Checks with Cash (Start) ===================== -->
    <ng-container *ngIf="isChecks() || isChecksCash() || isCreditCard() || isBankTransferCash()">
      <div class="w24" *ngIf="isChecks() || isChecksCash()">
        <div class="l-flex l-flex-c t-field t-field-pad" style="height: 81%">
          <label>
            {{ "billing.gui.labels.Number of Payments" | translate }}
          </label>
          <i class="t-sep"></i>
          <span class="t-validation-wrap l-fg1">
            <select formControlName="numberOfPayments" class="t-select-black w100">
              <option *ngFor="let number of numberOfPayments" [value]="number">
                {{ number }}
              </option>
            </select>
          </span>
        </div>
      </div>
      <div *ngIf="isChecksCash() || isCashCard() || isBankTransferCash()" class="inputs-container">
        <div class="l-flex l-flex-c t-field t-field-pad" style="height: 81%">
          <label>
            {{ "billing.gui.labels.Cash" | translate }}
          </label>
          <i class="t-sep"></i>
          <span class="t-validation-wrap l-fg1">
            <span class="t-field t-field--number" style="padding: 0">
              <input formControlName="cash" class="t-field-text" type="number" min="0" />
              <span class="t-field-desc"> ₪ </span>
            </span>
          </span>
          <button
            *ngIf="invoiceForm.get('cash').value && invoiceForm.get('price').value"
            (click)="calculate()"
            class="orange-btn"
          >
            {{ "billing.gui.buttons.Calculate Price" | translate }}
          </button>
        </div>
      </div>
      <div
        class="search-results"
        [formGroup]="invoiceForm"
        style="width: 100%"
        *ngIf="isChecks() || isChecksCash()"
      >
        <div class="container">
          <ng-container formArrayName="checks">
            <table style="width: 100%">
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {{ "billing.gui.labels.Bank Number" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Bank Branch" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Account Number" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Check Number" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Expiration Date" | translate }}
                  </th>
                  <th>
                    {{ "billing.gui.labels.Amount" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let check of checks.controls; let i = index" [formGroupName]="i">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <input formControlName="bankNumber" type="number" class="search-patient-field" />
                  </td>
                  <td>
                    <input formControlName="bankBranch" type="number" class="search-patient-field" />
                  </td>
                  <td>
                    <input formControlName="accountNumber" type="number" class="search-patient-field" />
                  </td>
                  <td>
                    <input formControlName="checkNumber" type="number" class="search-patient-field" />
                  </td>
                  <td>
                    <div class="search-patient-field">
                      <span class="t-validation-wrap l-fg1" style="display: flex">
                        <input
                          matInput
                          [matDatepicker]="picker"
                          formControlName="date"
                          class="t-field-text w100"
                        />
                        <mat-datepicker #picker></mat-datepicker>
                        <img
                          src="../../assets/icons/date.svg"
                          (click)="picker.open()"
                          style="cursor: pointer"
                        />
                      </span>
                      <i class="t-sep"></i>
                    </div>
                  </td>
                  <td>
                    <span class="search-patient-field" style="display: flex; align-items: center">
                      <input formControlName="amount" type="number" class="amount-input" />
                      <span class="t-field-desc"> ₪ </span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <!-- ===================== Checks / Checks with Cash (End) ===================== -->

    <!-- ===================== Bank Transfer (Start) ===================== -->
    <ng-container *ngIf="isBankTransfer()">
      <div class="search-results" [formGroup]="invoiceForm" style="width: 100%">
        <div formGroupName="bankTransfer" class="container">
          <table style="width: 100%">
            <thead>
              <tr>
                <th>
                  {{ "billing.gui.labels.Bank Number" | translate }}
                </th>
                <th>
                  {{ "billing.gui.labels.Bank Branch" | translate }}
                </th>
                <th>
                  {{ "billing.gui.labels.Account Number" | translate }}
                </th>
                <th>
                  {{ "billing.gui.labels.Date" | translate }}
                </th>
                <th *ngIf="isCash()">₪</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input formControlName="bankNumber" type="number" class="search-patient-field" />
                </td>
                <td>
                  <input formControlName="bankBranch" type="number" class="search-patient-field" />
                </td>
                <td>
                  <input formControlName="accountNumber" type="number" class="search-patient-field" />
                </td>
                <td>
                  <div class="search-patient-field">
                    <span class="t-validation-wrap l-fg1" style="display: flex">
                      <input
                        matInput
                        [matDatepicker]="picker"
                        formControlName="date"
                        class="t-field-text w100"
                      />
                      <mat-datepicker #picker></mat-datepicker>
                      <img
                        src="../../assets/icons/date.svg"
                        (click)="picker.open()"
                        style="cursor: pointer"
                      />
                    </span>
                    <i class="t-sep"></i>
                  </div>
                </td>
                <td *ngIf="isCash()">
                  <input
                    formControlName="amount"
                    type="number"
                    class="search-patient-field"
                    (keyup)="creditPrice('amount')"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
    <!-- ===================== Bank Transfer (End) ===================== -->

    <!-- ===================== Credit Card (Start) ===================== -->
    <ng-container *ngIf="isCreditCard()">
      <div class="search-results" [formGroup]="invoiceForm" style="width: 100%">
        <div formGroupName="creditCard" class="container">
          <table style="width: 100%">
            <thead>
              <tr>
                <th>
                  {{ "billing.gui.labels.Card Number" | translate }}
                </th>
                <th>
                  {{ "billing.gui.labels.Number of Payments" | translate }}
                </th>
                <th>
                  {{ "billing.gui.labels.transaction.referenceNumber" | translate }}
                </th>
                <th *ngIf="isCash()">₪</th>
                <!--
                                <th>
                                    {{'billing.gui.labels.Expiration Date' | translate}}
                                </th>
                                
                                <th>
                                    {{'billing.gui.labels.CVV' | translate}}
                                </th>
                                <th>
                                    {{'billing.gui.labels.Card Holder ID' | translate}}
                                </th>-->
              </tr>
            </thead>
            <tbody>
              <tr style="opacity: 0.5">
                <td>
                  <input formControlName="cardNumber" type="number" class="search-patient-field" />
                </td>
                <td>
                  <select
                    formControlName="numberOfPayments"
                    class="search-patient-field"
                    (dblclick)="invoiceForm.get('creditCard').get('numberOfPayments').setValue('')"
                  >
                    <option *ngFor="let number of creditPayments" [value]="number">
                      {{ number }}
                    </option>
                  </select>
                </td>
                <td>
                  <input formControlName="transactionId" type="number" class="search-patient-field" />
                </td>
                <td *ngIf="isCash()">
                  <input
                    formControlName="ccAmt"
                    type="number"
                    class="search-patient-field"
                    (keyup)="creditPrice('cc')"
                  />
                </td>
                <!-- <td matTooltip="Double Click To Remove"> -->
                <!--<td>
                                    <span
                                        (dblclick)="invoiceForm.get('creditCard').get('expirationMonth').setValue('')">
                                        <select formControlName="expirationMonth" class="small-select">
                                            <option *ngFor="let month of months" [value]="month">
                                                {{ month }}
                                            </option>
                                        </select>
                                    </span>
                                    <span (dblclick)="invoiceForm.get('creditCard').get('expirationYear').setValue('')">
                                        <select formControlName="expirationYear" class="small-select">
                                            <option *ngFor="let year of years" [value]="year">
                                                {{ year }}
                                            </option>
                                        </select>
                                    </span>
                                </td>
                               
                                <td style="width: 5%; text-align: center;">
                                    <input formControlName="cvv" type="number" class="search-patient-field">
                                </td>
                                <td>
                                    <input formControlName="cardHolderId" type="number" class="search-patient-field">
                                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
    <!-- ===================== Credit Card (End) ===================== -->
  </div>

  <div style="display: flex">
    <button
      class="blue-btn"
      (click)="produceInvoice()"
      [disabled]="!isFormValid() || isLoading"
      [matTooltip]="getMissingFields().join(', ')"
    >
      {{ produceInvoiceBtn }}
    </button>

    <button class="orange-btn" (click)="newInvoice = false; resetInvoiceForm()" [disabled]="isLoading">
      {{ "billing.gui.buttons.Cancel" | translate }}
    </button>
    <div *ngIf="displayWarning" class="warning-message">
      {{ warningMessage }}
    </div>
    <button
      *ngIf="!isPreviewLoading"
      [ngClass]="!isFormValid() ? 'disabled' : 'clickable'"
      style="margin: 0 2em 0 2em"
      (click)="previewDocument()"
      [disabled]="!isFormValid()"
      matTooltip="{{ 'billing.gui.tooltips.Preview document' | translate }}"
    >
      <img src="../../assets/icons/searchdoc-blue.svg" />
    </button>
    <div *ngIf="isPreviewLoading" style="width: 3em">
      <img style="width: 100%; margin: 0 2em 0 2em" src="../../assets/images/Wedges.svg" />
    </div>
  </div>
</div>

<!-- ===================== Previous Invoices (Start) ===================== -->
<hr class="divider" />
<div *ngIf="showInvoices" class="search-results">
  <h3>
    {{ "billing.gui.labels.Previous Invoices" | translate }}
  </h3>

  <ng-container *ngIf="invoicesData?.length === 0">
    <div style="text-align: center">
      <h5>
        {{ "billing.gui.labels.No Previous Invoices Available" | translate }}
      </h5>
    </div>
  </ng-container>

  <ng-container *ngIf="invoicesData?.length > 0">
    <div class="container">
      <table style="width: 100%">
        <thead>
          <tr>
            <th>
              {{ "billing.gui.labels.Type" | translate }}
            </th>
            <th (click)="sortData('DateCreated')" class="clickable">
              {{ "billing.gui.labels.Creation Date" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.Number" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.For" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.ServiceDescription" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.Payment Method" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.Amount" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.Doctor" | translate }}
            </th>
            <!-- <th>Status</th> -->
            <th>
              {{ "billing.gui.labels.Printed" | translate }}
            </th>
            <th>
              {{ "billing.gui.labels.Options" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="isLoading" class="loading-row">
            <td *ngFor="let col of columns">
              <div class="loading-effect"></div>
            </td>
          </tr>
          <tr *ngFor="let invoice of invoicesData; let i = index">
            <td>{{ invoice.TypeName }}</td>
            <td>{{ invoice.DateCreated | date : "dd.MM.yyyy" }}</td>
            <td>{{ invoice.DocumentNumber }}</td>
            <td>{{ invoice.Recipient }}</td>
            <td>{{ invoice.Subject }}</td>
            <td>{{ invoice.PaymentMethodName }}</td>
            <!-- <td>{{invoice.Price}} ₪ </td> -->
            <td>{{ adjustPrice(invoice) }} ₪</td>
            <td>{{ invoice.DoctorName }}</td>
            <!-- <td>
                            <span class="status">
                                {{invoice.DocumentStatusLabel}}
                            </span>
                        </td> -->
            <td>
              <div style="display: flex; justify-content: center">
                <input type="checkbox" disabled readonly [checked]="invoice.Printed" />
              </div>
            </td>
            <td>
              <div style="display: flex; justify-content: space-evenly; gap: 0.5em">
                <!-- <img src="../../assets/icons/print-blue.svg" matTooltip="שלח להדפסה"
                                (click)="openNewTab(invoice.OriginLink)"> -->
                <button [disabled]="invoice.Printed">
                  <img
                    src="../../assets/icons/fileblue.svg"
                    style="width: 1.5em"
                    [ngClass]="invoice.Printed ? 'disabled' : 'clickable'"
                    [matTooltip]="
                      invoice.Printed
                        ? ('billing.gui.tooltips.Can\'t view the original again' | translate)
                        : ('billing.gui.tooltips.Click to view the source' | translate)
                    "
                    (click)="
                      openPdf(invoice.Printed, invoice.OriginLink);
                      originDocumentViewed(invoice.AutoIndex)
                    "
                  />
                </button>

                <button
                  [disabled]="!currentPatient?.Email || emailLoadingId === invoice.DocumentID"
                  [matTooltip]="!currentPatient?.Email ? ('billing.gui.tooltips.missing email' | translate) : ('billing.gui.tooltips.send email' | translate)"
                  (click)="sendEmail(invoice)"
                  style="width: 1.8em; display: flex; align-items: center; justify-content: center"
                >
                  <img
                    *ngIf="emailLoadingId !== invoice.DocumentID"
                    src="../../assets/icons/forward-to-inbox-blue.svg"
                    [ngClass]="!currentPatient?.Email ? 'disabled' : 'clickable'"
                    style="width: 1.8em"
                  />
                  <mat-spinner
                    *ngIf="emailLoadingId === invoice.DocumentID"
                    diameter="20"
                  ></mat-spinner>
                </button>

                <button>
                  <img
                    src="../../assets/icons/searchdoc-blue.svg"
                    class="clickable"
                    style="width: 1.8em"
                    [matTooltip]="'billing.gui.tooltips.Click to view the copy' | translate"
                    (click)="openPdf(false, invoice.CopyLink)"
                  />
                </button>

                <!-- Generate Invoice from Receipt (for Type 400 only) -->
                <button *ngIf="invoice.Type === 400 && hasUninvoicedChecks(invoice)" (click)="openGenerateInvoicePopup(invoice)">
                  <img
                    src="../../assets/icons/invoice-paid.svg"
                    class="clickable"
                    style="width: 1.5em"
                    [matTooltip]="'billing.gui.labels.Generate Invoices from Receipt' | translate"
                  />
                </button>

                <button [disabled]="disableCloseInvoiceButton(invoice.DocumentStatus, invoice.TypeName)">
                  <img
                    src="../../assets/icons/x-blue.svg"
                    [ngClass]="
                      disableCloseInvoiceButton(invoice.DocumentStatus, invoice.TypeName)
                        ? 'disabled'
                        : 'clickable'
                    "
                    style="width: 1.5em"
                    [matTooltip]="
                      disableCloseInvoiceButton(invoice.DocumentStatus, invoice.TypeName)
                        ? ''
                        : ('billing.gui.tooltips.To Cancel' | translate)
                    "
                    (click)="selectInvoice(invoice)"
                  />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
<!-- ===================== Previous Invoices (End) ===================== -->

<!-- ===================== Invoices Cancellation (Start) ===================== -->
<div *ngIf="!showInvoices && selectedInvoice">
  <div>
    <h3>Cancellation of Invoices and Receipts</h3>
    <div style="direction: rtl">
      <span>
        <strong>
          {{ selectedInvoice.TypeName }}
        </strong>
        {{ "billing.gui.labels.Produced for" | translate }}:
        <strong>
          {{ selectedInvoice.Recipient }}
        </strong>
        {{ "billing.gui.labels.Price" | translate }}:
        <strong>
          {{ selectedInvoice.Price }}
        </strong>
        ₪
      </span>
      <div>
        <pre>
                    <strong>
                        {{ cancellationMessage(selectedInvoice.TypeName) }}
                    </strong>
                </pre>
        <div>
          <button class="orange-btn" style="width: 4em" (click)="toggleCloseInvoicePopup()">
            {{ "billing.gui.buttons.Yes" | translate }}
          </button>
          <!-- <button class="orange-btn" style="width: 4em;" (click)="confirmCancelation(true)">כן</button> -->
          <button class="blue-btn" style="width: 4em" (click)="toggleInvoices()">
            {{ "billing.gui.buttons.No" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="isPDFLoading" style="display: flex; justify-content: center">
      <img src="../../assets/images/Wedges.svg" />
    </div>

    <embed
      *ngIf="selectedInvoice.pdfUrl && !isPDFLoading"
      [src]="selectedInvoice.pdfUrl | safeUrl"
      type="application/pdf"
      style="width: 100%; height: 80vh; z-index: 1"
    />
  </div>
  <ng-container *ngIf="showCloseInvoice">
    <div class="overlay"></div>
    <div
      cdkDrag
      class="pop-up"
      [formGroup]="cancellationForm"
      [ngClass]="{ open: showCloseInvoice, close: !showCloseInvoice }"
    >
      <div cdkDragHandle class="t-popup-frame drag-handle" style="display: flex; flex-direction: column">
        <button
          class="t-btn-popup-close"
          style="z-index: 9; top: 1.7em; left: 1.7em"
          aria-label="close popup"
          title="Close"
          (click)="toggleCloseInvoicePopup()"
        ></button>

        <div
          class="t-popup-body"
          (mousedown)="$event.stopPropagation()"
          (touchstart)="$event.stopPropagation()"
        >
          <h2 style="direction: rtl">
            {{ handleCancelTitle() }}
          </h2>
          <span style="display: flex; direction: rtl">
            {{ selectedInvoice.TypeName }}
            היתה לסכום
            {{ selectedInvoice.Price }}₪ ניתן לזכות עד {{ selectedInvoice.Price }}₪
          </span>
          <div
            class="l-flex l-flex-w t-fieldmargin patient-details"
            style="display: flex; justify-content: right; margin-top: 1em"
          >
            <div class="inputs-container">
              <div class="l-flex l-flex-c t-field t-field-pad" style="height: 70%">
                <span class="t-validation-wrap l-fg1">
                  <span class="t-field t-field--number" style="padding: 0">
                    <input formControlName="price" class="t-field-text" type="number" min="0" />
                    <span class="t-field-desc"> ₪ </span>
                  </span>
                </span>
              </div>
            </div>
            <div *ngIf="handleCancelPrice()" class="t-validation-wrap">
              <button class="t-menu-item is-invalid-right"></button>
              <div
                class="t-validation-message-right"
                style="width: fit-content; top: 9.8em; left: -14em; font-size: medium; position: fixed"
              >
                <span style="border-radius: 8px">
                  <p style="margin-bottom: 1em">
                    {{ handleCancelPrice() }}
                  </p>
                </span>
              </div>
            </div>
          </div>
          <div class="w100">
            <div class="l-flex l-flex-c t-field t-field-pad" style="border-radius: 5px">
              <span class="t-validation-wrap l-fg1">
                <textarea formControlName="description" class="t-field-text w100"></textarea>
              </span>
            </div>
          </div>

          <button
            *ngIf="selectedInvoice.TypeName === 'חשבונית מס'"
            class="blue-btn"
            (click)="produceCreditInvoice()"
            [disabled]="disableCancellation()"
          >
            {{ "billing.gui.buttons.Create New Document" | translate }}
          </button>
          <button
            *ngIf="selectedInvoice.TypeName === 'קבלה'"
            class="blue-btn"
            (click)="produceCancelReceipt()"
            [disabled]="disableCancellation()"
          >
            {{ "billing.gui.buttons.Create New Document" | translate }}
          </button>
          <button
            *ngIf="selectedInvoice.TypeName === 'חשבונית מס / קבלה'"
            class="blue-btn"
            (click)="produceCancelCreditReceipt()"
            [disabled]="disableCancellation()"
          >
            {{ "billing.gui.buttons.Create New Document" | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<!-- ===================== Invoices Cancellation (End) ===================== -->
<ng-container *ngIf="result">
  <div class="overlay"></div>
  <div class="result-pop-up" [ngClass]="{ open: result, close: !result }">
    <div class="t-popup-frame" style="display: flex; flex-direction: column; max-width: 25em">
      <button
        title="Close"
        class="t-btn-popup-close"
        style="z-index: 9999; top: 1.7em; right: 1.7em"
        aria-label="close popup"
        (click)="result = false"
      ></button>

      <div class="t-popup-body">
        <h2
          style="
            text-align: center;
            font-size: x-large;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 1em;
          "
        >
          {{ resultMessage }}
        </h2>
      </div>
    </div>
  </div>
</ng-container>

<!-- ===================== Generate Invoice from Receipt (Start) ===================== -->
<ng-container *ngIf="showGenerateInvoicePopup && selectedReceiptForInvoice">
  <div class="overlay"></div>
  <div cdkDrag class="pop-up" [ngClass]="{ open: showGenerateInvoicePopup, close: !showGenerateInvoicePopup }">
    <div cdkDragHandle class="t-popup-frame drag-handle" style="display: flex; flex-direction: column">
      <button
        class="t-btn-popup-close"
        style="z-index: 9; top: 1.7em; left: 1.7em"
        aria-label="close popup"
        title="Close"
        (click)="closeGenerateInvoicePopup()"
      ></button>

      <div class="t-popup-body" (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()">
        <h2 style="direction: rtl">
          {{ "billing.gui.labels.Generate Invoices from Receipt" | translate }}
        </h2>
        <p style="direction: rtl">
          {{ "billing.gui.labels.Receipt" | translate }}: {{ selectedReceiptForInvoice.DocumentNumber }}
        </p>

        <ng-container *ngIf="receiptChecks && receiptChecks.length > 0">
          <!-- Direct Receipt (no checks) -->
          <ng-container *ngIf="receiptChecks[0].Type === 'Receipt'">
            <p style="direction: rtl">
              <!-- {{ "billing.gui.labels.No uninvoiced checks found" | translate }}<br>
              {{ "billing.gui.labels.Generate invoice directly from receipt" | translate }} -->
            </p>
            <div class="container" style="max-height: 400px; overflow-y: auto">
              <table style="width: 100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ "billing.gui.labels.Type" | translate }}</th>
                    <th>{{ "billing.gui.labels.Amount" | translate }}</th>
                    <th>{{ "billing.gui.labels.Date" | translate }}</th>
                    <th>{{ "billing.gui.labels.Options" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of receiptChecks; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.Type || 'Receipt' }}</td>
                    <td>{{ item.Amount || item.amount }} ₪</td>
                    <td>{{ item.checkDate | date : "dd.MM.yyyy" }}</td>
                    <td>
                      <button
                        class="blue-btn"
                        (click)="generateInvoiceFromItem(item)"
                        [disabled]="loadingCheckId === item.AutoIndex"
                      >
                        {{  "billing.gui.buttons.Create New Document" | translate }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <!-- Checks (with bank and expiration date) -->
          <ng-container *ngIf="receiptChecks[0].Type !== 'Receipt'">
            <p style="direction: rtl">
              {{ "billing.gui.labels.Uninvoiced items found" | translate }}: {{ receiptChecks.length }}
            </p>
            <div class="container" style="max-height: 400px; overflow-y: auto">
              <table style="width: 100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ "billing.gui.labels.Type" | translate }}</th>
                    <th>{{ "billing.gui.labels.Bank Number" | translate }}</th>
                    <th>{{ "billing.gui.labels.Check Number" | translate }}</th>
                    <th>{{ "billing.gui.labels.Amount" | translate }}</th>
                    <th>{{ "billing.gui.labels.Expiration Date" | translate }}</th>
                    <th>{{ "billing.gui.labels.Options" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of receiptChecks; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.Type || 'Check' }}</td>
                    <td>{{ item.bank || '-' }}</td>
                    <td>{{ item.Number || '-' }}</td>
                    <td>{{ item.amount }} ₪</td>
                    <td>{{ item.checkDate | date : "dd.MM.yyyy" }}</td>
                    <td>
                      <button
                        class="blue-btn"
                        (click)="generateInvoiceFromItem(item)"
                        [disabled]="loadingCheckId === item.AutoIndex"
                      >
                        {{  "billing.gui.buttons.Create New Document" | translate }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!receiptChecks || receiptChecks.length === 0">
          <p style="direction: rtl; color: green">
            {{ "billing.gui.labels.No uninvoiced items found" | translate }}
          </p>
        </ng-container>

        <button class="orange-btn" (click)="closeGenerateInvoicePopup()">
          {{ "billing.gui.buttons.Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
<!-- ===================== Generate Invoice from Receipt (End) ===================== -->
